/**
 * Лента новостей продукта для панели уведомлений.
 *
 * ПОЧЕМУ В КОДЕ, А НЕ В БАЗЕ. Уведомления эталона - это новости платформы:
 * вышла игра, открылось сообщество, список исправлений. Их пишет владелец, а
 * не пользователь, они меняются вместе с релизом и не требуют ни таблицы, ни
 * панели администратора. Как только появится вторая точка редактирования -
 * переедут; сейчас лишний контур данных стоил бы дороже пользы.
 *
 * Тексты СВОИ (CLAUDE.md, «Дисциплина источников»): у эталона копируется
 * структура панели и её поведение, а не содержимое.
 *
 * ЛЕНТА ПОМЕЧЕНА КАК ПРИМЕРЫ, и это не формальность. Источника у неё нет:
 * записи зашиты в код и не обновляются ничем. Непомеченная лента читается как
 * живая - стример ждёт от неё новостей, которых не будет, и не узнаёт о
 * настоящих. Пометка снимается вместе с появлением источника.
 *
 * Сами записи при этом ПРАВДИВЫ: все четыре описывают то, что в продукте уже
 * есть, и датированы днём, когда появилось. Выдуманных цифр в них нет.
 */
export const NEWS_ARE_EXAMPLES = true;
export interface NewsItem {
  id: string;
  title: string;
  /** Короткая строка для списка. */
  snippet: string;
  /** Полный текст для второго уровня панели. Абзацы разделены пустой строкой. */
  body: string;
  /** Когда вышло, ISO. */
  date: string;
  /** Куда ведёт ссылка в конце: путь внутри консоли. */
  link?: { title: string; to: string };
  /**
   * Запись о тарифе Pro: рядом с ней стоит слово о том, можно ли его
   * оформить, - из одного источника со всеми местами (`ProStatus`).
   */
  pro?: true;
}

export const NEWS: NewsItem[] = [
  {
    id: 'razgon',
    title: 'Новая игра: «Разгон»',
    snippet:
      'Трёхмерная гонка, где чат толкает машину подарками, а трасса собирается из подарков зрителей.',
    body: `Трёхмерная гонка. Всё трёхмерное грузится, только когда игра выбрана: остальные игры оверлея от этого не тяжелеют.

Чат разгоняет машину комментариями, подарки дают ускорение, а серия подарков подряд считается одним рывком, а не десятью.

Легенда действий прибита нижней кромкой: на машинах с другим шрифтом она растёт вверх, а не в охранную зону TikTok.`,
    date: '2026-09-18',
    link: { title: 'Открыть каталог игр', to: '/app/games' },
  },
  {
    id: 'peredel',
    title: 'Первая игра тарифа Pro: «Передел»',
    snippet: 'Две стороны делят поле, каждый подарок сдвигает границу. Счёт идёт по площади.',
    body: `«Передел» — первая игра, где на поле десятки живых объектов сразу: каждый подарок зрителя сдвигает границу, и видно это на оверлее без задержек.

Даже на слабом ноутбуке оверлей тянет её так же, как простые игры: мы проверили это замерами до выпуска.`,
    date: '2026-09-17',
    pro: true,
    link: { title: 'Открыть каталог игр', to: '/app/games' },
  },
  {
    id: 'layout',
    title: 'Редактор раскладки прямо на превью',
    snippet:
      'Части оверлея двигаются мышью прямо на нём, с охранными зонами TikTok и переносом между играми.',
    body: `Редактор больше не отдельный экран: раскладка правится прямо на оверлее консоли.

Охранные зоны TikTok показаны на оверлее: интерфейс приложения перекрывает низ и правый край, и часть, уехавшую туда, зритель просто не увидит.

Раскладку одной игры можно перенести в другую, не настраивая заново.`,
    date: '2026-09-16',
  },
  {
    id: 'quota',
    title: 'Остаток эфира виден всегда',
    snippet: 'Минуты бесплатного тарифа и момент сброса — в верхней полосе, а не в счёте после.',
    body: `Остаток дневного эфира стоит в верхней полосе и виден на любом экране консоли.

Момент сброса называется по вашему местному времени, а не в UTC: «сброс в 05:00» посреди ночного эфира — плохая новость, но знать её надо заранее.`,
    date: '2026-09-14',
    link: { title: 'Посмотреть тариф', to: '/app/plan' },
  },
  {
    id: 'welcome',
    title: 'Добро пожаловать в Efira Live',
    snippet: 'Как запустить первую игру: ссылка оверлея, источник «Браузер» в OBS, симулятор.',
    body: `Скопируйте ссылку оверлея из верхней полосы и добавьте её источником «Браузер» в OBS, Streamlabs или TikTok LIVE Studio. Ссылка постоянная: один раз настроили — работает каждый эфир.

Выберите игру в каталоге. Она запустится в превью, и в TikTok при этом ничего не уйдёт.

Запустите симулятор: он покажет, как игра ведёт себя на живых зрителях, и не потратит ни минуты дневной квоты.`,
    date: '2026-09-10',
  },
];
